// Toggle the menu open and close when on mobile
export default function menuOpen() {
    const burgerButtons = document.querySelectorAll('.gh-burger');
    burgerButtons.forEach(function(burgerButton) {
        burgerButton.addEventListener('click', function() {
            document.body.classList.toggle('gh-head-open');
        });
    });
    function handleResize() {
        if (window.innerWidth >= 1024) {
            var activeElements = document.querySelectorAll('.active');
            activeElements.forEach(function(element) {
                element.classList.remove('active');
            });
            var openedElements = document.querySelectorAll('.opened');
            openedElements.forEach(function(element) {
                element.classList.remove('opened');
            });
        }
    }
    window.addEventListener('resize', handleResize);
    var openers = document.querySelectorAll('.opener');
    openers.forEach(function(opener) {
        opener.addEventListener('click', function() {
            var nextSibling = opener.nextElementSibling;
            if (nextSibling.classList.contains('submenu-wrapper')) {
                nextSibling.classList.toggle('active');
            }
            opener.classList.toggle('opened');
        });
    });

    document.addEventListener('DOMContentLoaded', function() {
        var parentElement = document.querySelector('li.parent');
        var overlay = document.querySelector('.menu-overlay');
        var body = document.body;

        parentElement.addEventListener('mouseenter', function() {
            overlay.classList.add('active');
            body.classList.add('menu-opened');
        });

        parentElement.addEventListener('mouseleave', function() {
            overlay.classList.remove('active');
            body.classList.remove('menu-opened');
        });
    });
}
